export default "__VITE_ASSET__561a5a47__$_?component__"